exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CellAdjustment .flyout-item-label,.CellTextAlignment .flyout-item-label{text-transform:none!important}.CellAdjustment{min-width:250px!important}.CellTextAlignment{min-width:200px!important}.CellFormat{min-width:300px!important}", ""]);

// exports
